import '../setup_saml_check/styles'
import setupSamlCheck from '../setup_saml_check'

setupSamlCheck(document.querySelector('.setup-saml-check'))
